// The lembar disposisi for one document: who handed it on, since when, the
// instruction that came with it, and whose turn it is now. Derived only from
// the document's own riwayat and status (docs/contract.md section 3).
import type { DocumentDetail, DocumentEvent } from "../api";

export interface Disposition {
  from: string;
  since: string;
  instruction: string;
  waitingOn: string;
}

const HANDOFFS: DocumentEvent["action"][] = ["submit", "request_revision", "approve", "finalize", "reopen"];

function latest(events: DocumentEvent[], actions: DocumentEvent["action"][]): DocumentEvent | null {
  let best: DocumentEvent | null = null;
  for (const e of events) {
    if (!actions.includes(e.action)) continue;
    if (!best || e.createdAt > best.createdAt) best = e;
  }
  return best;
}

/** `penyedia`: a Penyedia's own document, finalized by its maker (no "finalisasi" wording). */
export function dispositionOf(
  doc: Pick<DocumentDetail, "status" | "events" | "reviewNote" | "createdByName" | "updatedAt" | "allowedActions">,
  penyedia = false,
): Disposition {
  const hand = latest(doc.events, HANDOFFS);
  const made = latest(doc.events, ["generate", "regenerate", "edit"]);
  switch (doc.status) {
    case "review": {
      const e = latest(doc.events, ["submit"]);
      return {
        from: e?.actorName ?? doc.createdByName,
        since: e?.createdAt ?? doc.updatedAt,
        instruction: e?.note?.trim() || "Periksa isi draf, lalu setujui atau minta revisi.",
        waitingOn: "PA/KPA",
      };
    }
    case "revisi": {
      const e = latest(doc.events, ["request_revision", "reopen"]);
      return {
        from: e?.actorName ?? doc.createdByName,
        since: e?.createdAt ?? doc.updatedAt,
        instruction: doc.reviewNote?.trim() || e?.note?.trim() || "Perbaiki isi dokumen, lalu lanjutkan alurnya.",
        waitingOn: doc.createdByName,
      };
    }
    case "final": {
      const e = latest(doc.events, ["approve", "finalize"]);
      return {
        from: e?.actorName ?? hand?.actorName ?? doc.createdByName,
        since: e?.createdAt ?? doc.updatedAt,
        instruction: e?.note?.trim() || "Dokumen sudah final. Buka kembali bila isinya perlu diubah.",
        waitingOn: "Tidak ada, alur selesai",
      };
    }
    default: {
      const next = doc.allowedActions.includes("submit")
        ? "Periksa draf dari Pluto, lalu ajukan review ke PA/KPA."
        : doc.allowedActions.includes("finalize")
          ? penyedia
            ? "Periksa draf dari Pluto terhadap dokumen pemilihan, lalu tandai final bila sudah sesuai."
            : "Periksa draf dari Pluto, lalu finalisasi bila sudah sesuai."
          : "Draf dari Pluto menunggu diperiksa pembuatnya.";
      return {
        from: made?.actorName ?? doc.createdByName,
        since: made?.createdAt ?? doc.updatedAt,
        instruction: next,
        waitingOn: doc.createdByName,
      };
    }
  }
}
